import { Box, Button, Stack, Typography, theme } from '@dtx-company/design-system/src'
import { Dialog } from '@mui/material'
import { EmptyShoppingCartAnimation } from '@app/code/src/components/ShoppingCart/EmptyShoppingCart/EmptyShoppingCartAnimation'
import { ModalTypes } from '@dtx-company/inter-app/src/redux/slices/modal'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import { useModal } from '@dtx-company/inter-app/src/redux/slices/utils'
import { useV3NavigationTopOffset } from '../../../side/v3/hooks'
import React from 'react'
import events from '@dtx-company/inter-app/src/event-tracking/events/nav'

export const CartEmptyStateDialog: React.FC = () => {
  const { setClose, modalOpen } = useModal(ModalTypes.DESKTOP_SHOPPING_CART_EMPTY_STATE_MODAL)
  const { sideNavTopOffset: dialogTopOffset } = useV3NavigationTopOffset()
  const DIALOG_RIGHT_OFFSET = 128
  return (
    <Dialog
      data-testid="desktop-cart-empty-state-dialog"
      open={modalOpen}
      onClose={setClose}
      hideBackdrop
      sx={{
        position: 'fixed',
        top: `${dialogTopOffset - 8}px`,
        right: DIALOG_RIGHT_OFFSET,
        '& .MuiDialog-container': {
          alignItems: 'flex-start',
          justifyContent: 'flex-end'
        }
      }}
      PaperProps={{
        sx: {
          width: theme.spacing(81.5),
          margin: 0,
          borderWidth: theme.spacing(0, 0.25, 0.25, 0.25),
          borderStyle: 'solid',
          borderColor: 'border.divider',
          padding: theme.spacing(0, 7, 7, 7)
        }
      }}
    >
      <Stack direction="column" sx={{ textAlign: 'center', alignItems: 'center' }}>
        <Box sx={{ width: '50%', minHeight: theme.spacing(60) }}>
          <EmptyShoppingCartAnimation />
        </Box>
        <Typography variant="subtitleMedium">Your cart is empty</Typography>
        <Spacer mb={['4px', '13px']} />
        <Typography variant="bodySmall">Browse our products to get started</Typography>
        <Spacer mb="26px" />
        <Button
          color="primary"
          href={Routes.PRINT_STORE_LANDING_PAGE}
          fullWidth
          onClick={() => {
            setClose()
            events.Platform_Desktop_TopNav_CartEmptyState_Clicked_VisitPrintStoreButton()
          }}
        >
          Buy prints of your Flowcodes
        </Button>
      </Stack>
    </Dialog>
  )
}
